import { Component, Inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

export type IdleWarningResult = 'stay' | 'logout';

export interface IdleWarningDialogData {
  secondsRemaining$: Observable<number>;
}

@Component({
    selector: 'uw-idle-warning-dialog',
    templateUrl: './idle-warning-dialog.component.html',
    styleUrls: ['./idle-warning-dialog.component.scss'],
    imports: [AsyncPipe, TranslateModule]
})
export class IdleWarningDialogComponent {

  readonly timeRemaining$ = this.data.secondsRemaining$.pipe(
    map(seconds => {
      const total = Math.max(0, Math.floor(seconds));
      const mm = Math.floor(total / 60).toString().padStart(2, '0');
      const ss = (total % 60).toString().padStart(2, '0');
      return `${mm}:${ss}`;
    })
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: IdleWarningDialogData,
    private readonly _dialogRef: MatDialogRef<IdleWarningDialogComponent, IdleWarningResult>
  ) { }

  close(result: IdleWarningResult) {
    this._dialogRef.close(result);
  }
}
